/** Multiplicador de la cuota recurrente según frecuencia de facturación. */
export const BILLING_FREQ_MULTIPLIERS = { Mensual: 1, Trimestral: 3, Semestral: 6, Anual: 12 };

/**
 * Frecuencia a mostrar en Kanban / banners.
 * Propuestas operativas (Por Cobrar) no deben heredar "Anual" de una opción CRM
 * si el anexo ya dice Mensual: eso convierte MRR en un "total anual" falso.
 */
export function resolveDisplayBillingFrequency(contract = {}) {
  const anexo = contract.anexo || {};
  const proposal = contract.proposal || {};
  const opciones = Array.isArray(proposal.opciones) ? proposal.opciones : [];
  const active = opciones.find((o) => o.isRecommended) || opciones[0];
  if (proposal.source === 'operational') {
    return anexo.billingFrequency
      || proposal.billingFrequency
      || contract.billingFrequency
      || 'Mensual';
  }
  return active?.billingFrequency
    || (active?.billingCycle === 'anual' ? 'Anual' : null)
    || anexo.billingFrequency
    || proposal.billingFrequency
    || contract.billingFrequency
    || 'Mensual';
}

/** Cuota del periodo (mensual × frecuencia) + servicios de pago único. */
export function contractDisplayAmountFromMonthly(monthlyRecurring, oneTime, frequency) {
  const mult = BILLING_FREQ_MULTIPLIERS[frequency] || 1;
  return (Number(monthlyRecurring) || 0) * mult + (Number(oneTime) || 0);
}
